import { Component, Input, OnInit } from '@angular/core';
import { DacConfig } from "./shared/services/dac-config.service";
import { AuthService } from './login/services/auth.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
declare var _paq;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent  implements OnInit {

  @Input() isAdmin:boolean;

  constructor(private authService:AuthService, private dacConfig:DacConfig
    ,private route:ActivatedRoute, private router:Router) {
    // authService.isAdmin = true;
      var currentUrl = this.route.snapshot.url.join("/");
      const navEndEvent$ = router.events.pipe(
        filter(e => e instanceof NavigationEnd)
      );
      navEndEvent$.subscribe((e: NavigationEnd) => {
        _paq.push(['setReferrerUrl', currentUrl]);
        currentUrl = e.urlAfterRedirects;
        _paq.push(['setCustomUrl', currentUrl]);
        // _paq.push(['setDocumentTitle', 'My New Title']);

        // remove all previously assigned custom variables, requires Matomo (formerly Piwik) 3.0.2
        _paq.push(['deleteCustomVariables', 'page']); 
        _paq.push(['setGenerationTimeMs', 0]);
        _paq.push(['trackPageView']);
      });
  }

  ngOnInit() {
    // test assumption that this always fires even if there are no parameters...
    this.route.queryParams.subscribe(params => {
      console.log("Query params are subscribed inside ngAfterViewInit()", params);
      if (params.seamless) {
        this.dacConfig.setupSeamlessModeForSession(params.skin);
      }
      else if (params.skin && params.skin.length) {
        this.dacConfig.replaceSkinClasses([params.skin]);
      }
      console.log("Config file skin classes are now ", this.dacConfig.skinClasses);

      let body = document.querySelector("body");
      let className = this.dacConfig.skinClasses.join(" ");
      body.className = className;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts